import API from "../api/axiosConfig";

export const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

// Guarda tokens/usuario en localStorage y redirige según el rol — mismo patrón
// para login tradicional, Google y WhatsApp OTP.
export const storeSessionAndRedirect = async (res, nav) => {
  const payload = res.data?.data ?? res.data;
  const user    = payload?.user  ?? payload;
  const tokens  = payload?.tokens ?? {};

  localStorage.setItem("token",        tokens.accessToken  ?? "");
  localStorage.setItem("accessToken",  tokens.accessToken  ?? "");
  localStorage.setItem("refreshToken", tokens.refreshToken ?? "");
  localStorage.setItem("user",         JSON.stringify(user));

  if (user.role === "ryder") {
    try {
      const ryderRes = await API.get(`/ryders/user/${user.id}`);
      const ryder = ryderRes.data?.data?.ryder ?? ryderRes.data?.ryder ?? ryderRes.data;
      localStorage.setItem("ryderId", ryder?.id ?? ryder?._id ?? "");
    } catch {}
  }

  if (user.role === "company")       nav("/company");
  else if (user.role === "admin")    nav("/admin");
  else if (user.role === "ryder")    nav("/ryder");
  else if (user.role === "delivery") nav("/delivery/dispatch");
  else nav("/");
};
